export default __webpack_public_path__ + "static/media/logo-shape.7d7ecc83.png";